/*
 * Eora cart glue.
 *
 * 1. Routes our custom Add-to-Bag buttons (product cards, PDP, sticky buy bar)
 *    through /cart/add.js and opens the Dawn cart drawer instead of navigating
 *    to the cart page.
 * 2. Keeps the free-gift line in sync: adds it when the eligible subtotal clears
 *    the threshold, removes it when the cart drops below. Runs on page load, after
 *    every add, and on Dawn's `cart-update` pub-sub event (native drawer qty/remove).
 *
 * The gift bar itself is rendered server-side (snippets/eora-gift-bar.liquid) inside
 * #CartDrawer, so it re-computes on every section render; this file only performs the
 * add/remove action by reading the bar's data-* attributes.
 */
(function () {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const url = (path) => (routeRoot.replace(/\/$/, '') + '/' + path);

  const drawer = () => document.querySelector('cart-drawer');
  let giftBusy = false;

  // Replace the rendered cart sections in place, reusing the drawer's own helpers,
  // optionally opening the drawer. Mirrors CartDrawer.renderContents minus the forced open.
  function applySections(cd, state, open) {
    if (!cd || !state || !state.sections) return;
    const inner = cd.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    cd.classList.remove('is-empty');
    cd.getSectionsToRender().forEach((section) => {
      const el = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const html = state.sections[section.id];
      if (!el || html == null) return;
      el.innerHTML = cd.getSectionInnerHTML(html, section.selector);
    });
    if (open && typeof cd.open === 'function') cd.open();
  }

  // ---- 1. Ajax add-to-cart -------------------------------------------------
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    const cd = drawer();
    if (!cd) return; // no drawer (page mode) → let it submit normally

    event.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    const body = new FormData(form);
    body.append('sections', SECTIONS.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(url('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body,
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) return; // add error (sold out etc.) — leave the page as-is
        applySections(cd, res, true);
        return syncGift();
      })
      .catch(() => {})
      .finally(() => btn && btn.removeAttribute('aria-busy'));
  });

  // ---- 2. Free-gift sync ---------------------------------------------------
  function syncGift() {
    if (giftBusy) return Promise.resolve();
    const bar = document.querySelector('[data-gift-auto-add]');
    if (!bar) return Promise.resolve();

    const qualifies = bar.dataset.qualifies === 'true';
    const inCart = bar.dataset.inCart === 'true';
    const available = bar.dataset.available === 'true';
    const variantId = Number(bar.dataset.variantId);
    const giftKey = bar.dataset.giftKey;

    let request = null;
    if (qualifies && !inCart && available) {
      request = fetch(url('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }],
          sections: SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
    } else if (!qualifies && inCart && giftKey) {
      // /cart/change.js needs a string id — the line key, because the gift line
      // carries a line-item property so the variant id isn't unique.
      request = fetch(url('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          id: giftKey,
          quantity: 0,
          sections: SECTIONS,
          sections_url: window.location.pathname,
        }),
      });
    }

    if (!request) return Promise.resolve();

    giftBusy = true;
    return request
      .then((r) => r.json())
      .then((res) => applySections(drawer(), res, false))
      .catch(() => {})
      .finally(() => {
        giftBusy = false;
      });
  }

  // Re-sync when Dawn's own cart controls (drawer qty steppers / remove) fire.
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => syncGift());
    }
    // Initial reconciliation (e.g. arriving on the cart page above threshold).
    syncGift();
  });
})();
